<template>
  <b-modal
    id="cust-tip-modal"
    title="Please select tip amount"
    hide-footer
    hide-header
  >
    <!-- TIP PERCENTAGE BUTTONS  -->
    <b-row>
      <b-col class="ml-4 mr-3 px-0">
        <b-form-group>
          <b-form-radio-group
            id="tip-modal-range"
            v-model="tipPercentage"
            :options="tipOptions"
            button-variant="outline-dark"
            class="tip-perc-buttons"
            buttons
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- MANUAL TIP NUMERIC BUTTONS -->
    <b-collapse id="numpad-collapse" v-model="numPadVisible">
      <b-row class="my-2">
        <b-col><h4 style="text-align:center;">Enter tip</h4></b-col>
      </b-row>
      <b-container fluid class="mx-auto num-pad-container">
        <b-row>
          <b-col class="px-0"><b-button class="numPadButton mx-auto" block variant="outline-dark" @click="updateNumPad(7)">7</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton mx-auto" block variant="outline-dark" @click="updateNumPad(8)">8</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton mx-auto" block variant="outline-dark" @click="updateNumPad(9)">9</b-button></b-col>
        </b-row>
        <b-row class="pt-3">
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(4)">4</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(5)">5</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(6)">6</b-button></b-col>
        </b-row>
        <b-row class="pt-3">
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(1)">1</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(2)">2</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(3)">3</b-button></b-col>
        </b-row>
        <b-row class="pt-3">
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="addDPToNumPad()">.</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-dark" @click="updateNumPad(0)">0</b-button></b-col>
          <b-col class="px-0"><b-button class="numPadButton" block variant="outline-danger" @click="delFromNumPad('C')"><b-icon icon="backspace"></b-icon></b-button></b-col>
        </b-row>
      </b-container>
      <!-- <b-row class="mt-3">
        <b-col cols="8" class="ml-4">
        </b-col>
        <b-col cols="2" class="pl-2 mr-4">
          <b-button class="numPadButton SideButton" block variant="outline-dark" @click="delFromNumPad('D')"><b-icon icon="backspace"></b-icon></b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8" class="ml-4">
        </b-col>
        <b-col cols="2" class="pl-2 mr-4 pt-3">
          <b-button class="numPadButton SideButton" block variant="primary" @click="emitPostTip(true)"><b-icon icon="arrow-return-right"></b-icon></b-button>
        </b-col>
      </b-row> -->
    </b-collapse>

    <b-row class="pl-2 pt-3 tip-summary">
      <b-col cols="5">Tip: {{ tipTotal | toCurrency }}</b-col>
      <b-col cols="7" class="pr-5"><span style="float:right;">Total: {{ orderPlusTip | toCurrency }}</span></b-col>
    </b-row>
    <hr>
    <b-row cols="2">
      <b-col>
        <b-button block variant="outline-danger" @click="emitPostTip(false)">No Tip</b-button>
      </b-col>
      <b-col>
        <b-button block variant="outline-success" @click="emitPostTip(true)">Confirm</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'CustomerTipModal',
  props: ['order_total'],
  data () {
    return {
      totalPaidAmount: this.order_total,
      setTipAmount: 0.00,
      tipPercentage: 0,
      tipOptions: [
        {text: '10%', value: 0.1},
        {text: '15%', value: 0.15},
        {text: '20%', value: 0.2},
        {text: '25%', value: 0.25},
        {text: 'Other', value: -1}
      ],
      numPadAmount: 0,
      dpAdded: false,
      numPadVisible: false
    }
  },

  watch: {
    // numPadAmount: function() {
    //   if (this.numPadAmount>0) {
    //     this.tipPercentage=-1;
    //   }
    // },

    tipPercentage: function() {
      if (this.tipPercentage>0) {
        this.numPadAmount=0
        this.numPadVisible=false
      } else if (this.tipPercentage == -1) {
        this.numPadVisible=true
      }
    }
  },

  computed: {
    tipTotal: function() {
      if (this.tipPercentage>0) {
        const tiptot = this.order_total*this.tipPercentage
        return Number(tiptot.toFixed(2))
      } else {
        return Number(this.numPadAmount);
      }
    },

    orderPlusTip: function() {
      return Number(this.order_total) + this.tipTotal;
    },

    tipDecimalPlaces: function() {
      if (String(this.numPadAmount).indexOf('.')!=-1) {
        return String(this.numPadAmount).split('.')[1].length
      } else {
        return 0
      }
    }

  },

  methods: {
    addDPToNumPad() {
      if (String(this.numPadAmount).indexOf('.')==-1) {
        this.numPadAmount = Number(this.numPadAmount).toFixed(1);
        this.dpAdded=true
      }
    },

    updateNumPad(val) {
      if (this.tipDecimalPlaces < 2 || this.tipPercentage > 0) {
        if (this.dpAdded) {
          this.numPadAmount = String(this.numPadAmount).slice(0,-1)
          this.dpAdded=false
        }
        const amnt = String(this.numPadAmount) + val
        this.numPadAmount = amnt
      }
    },

    delFromNumPad(val) {
      if (val=='D') {
        this.numPadAmount = String(this.numPadAmount).slice(0,-1)
        this.numPadAmount = Number(this.numPadAmount)
      } else if (val=='C') {
        this.numPadAmount = 0
        this.tipPercentage = -1
      }
    },

    // confirmTip() {
    //   this.$bvModal.msgBoxConfirm('Would you like to leave a tip of $'+this.tipTotal+'?', {
    //       title: 'Please Confirm Tip',
    //       okTitle: 'Confirm',
    //       cancelTitle: 'Back'
    //     })
    //     .then(value => {
    //       if (value==false) {
    //         this.$bvModal.show('cust-tip-modal');
    //       } else if (value==true) {
    //         this.emitPostTip(true);
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    // },

    emitPostTip(tipentered) {
      this.$bvModal.hide('cust-tip-modal');
      this.$emit('emit-post-tip', this.tipTotal, tipentered);
    },
  },
  mounted() {
    this.$bvModal.show('tip-modal');
  }
}
</script>

<style>

/* CSS Classes for Tip percentage buttons in each screen size */
  .numPadButton {
    height: 4.5rem;
    width: 4.5rem;
    font-size: 250%;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 360px) {
    .numPadButton {
      height: 5.5rem;
      width: 5.5rem;
    }
  }

  @media (min-width: 375px) {
    .numPadButton {
      height: 6rem;
      width: 6rem;
      font-size: 300%
    }
  }

  @media (min-width: 512px) {
    .num-pad-container {
      padding-left: 5rem;
      padding-right: 5rem;
    }
  }

/* CSS Classes for Tip percentage buttons in each screen size */
  .tip-perc-buttons {
    height: 40px;
    width: 100%;
    margin-left: -1rem;
  }

  #tip-modal-range .btn {
    font-size: 110%;
    padding-top:10px;
    margin-right: 0.3rem;
  }

  @media (min-width: 360px) {
    .tip-perc-buttons {
      margin-left: 0;
    }
  }

  @media (min-width: 375px) {
    #tip-modal-range .btn {
      font-size: 120%;
      padding-top:14px;
      margin-right: 0.5rem;
    }

    .tip-perc-buttons {
      height: 50px;
      margin-left: 0;
    }

  }

  @media (min-width: 512px) {
    #tip-modal-range .btn {
      font-size: 180%;
      padding-top:18px;
      margin-right: 1rem;
    }

    .tip-perc-buttons {
      height: 75px;
      width: 100%;
    }

  }

  @media (min-width: 1024px) {
    #tip-modal-range .btn {
      font-size: 150%;
    }
  }

/* tip summary */
  .tip-summary {
    font-size: 115%;
  }

  @media (min-width: 360px) {
    .tip-summary {
        font-size: 140%;
    }
  }
  @media (min-width: 512px) {
    .tip-summary {
      font-size: 200%;
    }
  }
</style>
